<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p34"><span><a href="#/Contents#rp34">CREAM OF BROCCOLI SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Eat broccoli often—it’s high in antioxidants and packed with nutrients.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>1 cup chopped onion</span></p>
<p class="hang"><span>3 cloves garlic, minced</span></p>
<p class="hang"><span>2 pounds broccoli, cut into pieces (2-inch)</span></p>
<p class="hang"><span>½ teaspoon dried thyme leaves</span></p>
<p class="hang"><span>⅛ teaspoon ground nutmeg</span></p>
<p class="hang"><span>3½ cups reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>½ cup fat-free half-and-half or fat-free milk</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="hang"><span>6 tablespoons fat-free sour cream</span></p>
<p class="hang"><span>1½ cups Croutons (½ recipe) (see <span href="#/Chapter131#p849" title="Link target outside of Sample">p. 636</span>)</span></p>
<p class="normalt"><span><b>1.</b> Sauté onion and garlic in lightly greased large saucepan until tender, 3 to 5 minutes. Stir in broccoli, thyme, and nutmeg; cook 2 minutes. Add broth to saucepan and heat to boiling; reduce heat and simmer, covered, until broccoli is tender, about 10 minutes. Stir in half-and-half. Process soup in food processor or blender until smooth; season to taste with salt and white pepper. Serve warm or chilled; stir 1 tablespoon sour cream into each bowl of soup and sprinkle with Croutons.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 99</span></p>
<p class="per1"><span>% calories from fat: 9</span></p>
<p class="per1"><span>Protein (g): 6.8</span></p>
<p class="per1"><span>Carbohydrate (g): 17.6</span></p>
<p class="per1"><span>Fat (g): 1.1</span></p>
<p class="per1"><span>Saturated fat (g): 0.2</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 110</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.5</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
<p class="normalt"><span><span class="small">VARIATIONS</span></span></p>
<p class="normala" id="p34a"><span><b>Dilled Broccoli Soup</b> — Make recipe as above, deleting thyme, nutmeg, and Croutons. Add ⅔ cup loosely packed fresh dill weed to soup when puréeing.</span></p>
<p class="normala" id="p34b"><span><a id="page_27"></a><b>Broccoli-Kale Soup</b> — Make recipe as above, increasing broth to 5 cups and deleting the half-and-half, Croutons, and nutmeg. Stir 2 cups lightly packed kale into the soup during the last 5 minutes of cooking time. Add more broth if needed for desired consistency.</span></p>
<p class="normala" id="p34c"><span><b>Cream of Asparagus Soup</b> — Make soup as above, substituting 2 pounds asparagus for the broccoli, and reserving 18 small asparagus tips for garnish. Omit thyme leaves. Add 1 teaspoon dried marjoram leaves and 1 teaspoon grated lemon zest. Steam reserved asparagus tips until crisp-tender, and use to garnish soup.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0216.vue?a2008a16